import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export class Logos {
    constructor(el) {
        this.el = el;

        this.sliders = this.el.querySelector(".logos__marquees");
        this.sliderTop = this.el.querySelector(".logos__marquee.top");
        this.sliderBottom = this.el.querySelector(".logos__marquee.bottom");

        this.splideTop = null;
        this.splideBottom = null;

        this.el && this.sliderTop && this.sliderBottom && this.init();
    }

    init() {
        const opts = {
            gap: 10,
            clones: Math.ceil(document.documentElement.clientWidth / 350 / 2),
            type: "loop",
            drag: "free",
            focus: "center",
            arrows: false,
            pagination: false,
            autoWidth: true,
            autoScroll: {
                speed: 0.5,
            },
        };
        this.splideTop = new Splide(this.sliderTop, opts);
        this.splideBottom = new Splide(this.sliderBottom, {
            ...opts,
            direction: "rtl",
        });

        this.splideBottom.on("mounted", () => {
            this.splideTop.Components.AutoScroll.pause();
            this.splideBottom.Components.AutoScroll.pause();

            const cards = this.el.querySelectorAll(".card-logo");
            cards.forEach(card => {
                card.addEventListener("mouseenter", this.handleCardEnter.bind(this));
            });
            cards.forEach(card => {
                card.addEventListener("mouseleave", this.handleCardLeave.bind(this));
            });
        });

        this.splideTop.mount({ AutoScroll });
        this.splideBottom.mount({ AutoScroll });

        this.sliders.addEventListener("mouseenter", this.handleHoverEnter.bind(this));
        this.sliders.addEventListener("mouseleave", this.handleHoverLeave.bind(this));
    }

    handleHoverEnter() {
        this.splideTop.Components.AutoScroll.pause();
        this.splideBottom.Components.AutoScroll.pause();
    }
    handleHoverLeave() {
        this.splideTop.Components.AutoScroll.play();
        this.splideBottom.Components.AutoScroll.play();
    }

    handleCardEnter(e) {
        e.target.addEventListener("mousemove", this.handleAddStyles.bind(this));
    }
    handleCardLeave(e) {
        e.target.classList.remove("is-active");
        e.target.closest(".card-logo").removeAttribute("style");
        e.target.removeEventListener("mousemove", this.handleAddStyles.bind(this));
    }
    handleAddStyles(e) {
        e.target.closest(".card-logo").style.setProperty("--x", e.offsetX - e.target.offsetWidth / 2);
        e.target.closest(".card-logo").style.setProperty("--y", e.offsetY - e.target.offsetHeight / 2);
    }

    destroy() {
        // Todo - Remove event listeners
        // this.sliders.removeEventListener("mouseenter", () => this.handleHoverEnter);
        // this.sliders.removeEventListener("mouseleave", () => this.handleHoverLeave);
        // this.cards.forEach(card => {
        //     card.removeEventListener("mouseenter", this.handleCardEnterBound);
        // });
        // this.cards.forEach(card => {
        //     card.removeEventListener("mouseleave", this.handleCardLeaveBound);
        // });
    }
}

const logos = () => {
    const logos = document.querySelectorAll(".logos");

    logos &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
        logos.forEach(el => {
            new Logos(el);
        });
};

export default logos;
